import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { RestApiService } from '../shared/restApiServices/restapi.service';
import { NativeWindoRefService } from '../shared/services/native-windo-ref.service';
import { Router } from '@angular/router';

@Component({
    selector: 'filter-dialog',
    templateUrl: 'filter-dialog.html',
    styleUrls: ['map-view.component.css']
})
export class FiltersDialogComponent {
    Questions = [];
    selectedQues:string;
    rangeFilter:boolean;
    optionsArray=[];
    operation:any;
    filterFields:any[];
    selectedQuesIndex:number;
    QuestionsData = [];
    value:number;
    constructor(private router: Router,
        public dialogRef: MatDialogRef<FiltersDialogComponent>, public restApiService: RestApiService, @Inject(MAT_DIALOG_DATA) public data: any) {
            this.Questions = this.data;
            for (let i in this.data) {
                this.QuestionsData.push(this.data[i].Qn);
              }
    }
    getQuesDetails(data) {
        this.selectedQuesIndex = this.Questions[data].Qn_Num;
        this.selectedQues = this.Questions[data].Qn;
        this.filterFields=[];
        if (this.Questions[data].Opt_Name.length != 0) {
          this.optionsArray = this.Questions[data].Opt_Name;
          this.operation = -1;
          this.rangeFilter = false;
        }
        else if(this.Questions[data].Qn_Disp_Value=='Number'){
          this.rangeFilter = true;
        }
        else{
          this.optionsArray = [];
        }
      }
      questionFilter(Question){
        if(Question.Qn_Disp_Value=='Number'||Question.Opt_Name.length>0)
        {
          return true;
        }
        else{
          return false;
        }
      }
      fieldsToFilter(data) {
        if (this.filterFields.indexOf(data) < 0) {
          this.filterFields.push(data);
        }
        else {
          this.filterFields.splice(this.filterFields.indexOf(data), 1);
        }
      }
      onApply() {
        if(this.operation!=-1)
        {
        this.filterFields.push(this.value);
        }
        // console.log(this.filterFields);
        // console.log(this.selectedQuesIndex);
        // console.log(this.operation);
    }

    onReset(){}

    operationFunc(data)
    {
      this.operation= data;
    }
}



// WEBPACK FOOTER //
// ./src/app/data-surveys/filter-dialog.ts